/// <reference path="../../../../Common/Helpers/GridEditorDialog.ts" />

namespace Matrix.Dashboards {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    export class ChartSeriesDialog extends Common.GridEditorDialog<ChartSeries> {
        protected getFormKey() { return ChartSeriesForm.formKey; }
        protected getNameProperty() { return "ValueField" }
        protected getEntitySingular() { return "Series"; }

        protected form = new ChartSeriesForm(this.idPrefix);

        constructor() {
            super();
        }
    }
}